import React from "react"
import { Row, Col } from "react-bootstrap"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import { useGalleriesAction } from "../../actions/useGalleriesAction"
import CircleImages from "../../components/CirclesImages"
import Container from "../../components/Layout/Container"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import { Loader } from "../../components/Layout/Loader"
import { SearchSortHeader } from "../../components/Layout/SearchSortHeader"
import Wrapper from "../../components/Layout/Wrapper"
import { SeoTags } from "../../components/Layout/SeoTags"

const GalleriesPage = ({ galleries: galleriesData }) => {
  const { galleries, setSearch, loading, loadingMore, setSort, sorts, sort } =
    useGalleriesAction(galleriesData)

  if (!galleries) {
    return null
  }

  return (
    <Wrapper>
      <SeoTags
        title="Galleries | Discover ArtPlacer"
        description="Explore our partner art galleries and artists."
        url="https://discover.artplacer.com/galleries"
        canonical="https://discover.artplacer.com/galleries"
      />
      <HelmetTitle title="Galleries" />
      <Container>
        <HeadingTitle title="Galleries">
          <span className="font-primary">
            Explore our Partner Galleries and Artists.
          </span>
          <p className="color-black">
            If you'd like to become a Partner Gallery, 
            <a className="fw-700" href="https://www.artplacer.com/signup/" target="_blank">
              <u>join our community.</u>
            </a>
          </p>
        </HeadingTitle>
        <SearchSortHeader
          title=""
          onChangeInput={(val) => setSearch(val)}
          sorts={sorts}
          sort={sort ?? "createddesc"}
          setSort={setSort}
          hideSearch={false}
        />

        {loading && <Loader />}
        {!loading && (
          <Row>
            {galleries.data.map((gallery) => {
              return (
                <Col
                  xl={2}
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  key={`galleries-${gallery.id}`}>
                  <CircleImages
                    title={gallery.name}
                    subtitle={gallery.address}
                    image={gallery.thumbnail}
                    to={linksBuilder.galleries(gallery.domain)}
                    href={`/galleries/[id]`}
                  />
                </Col>
              )
            })}
          </Row>
        )}
        {loadingMore && <Loader />}
      </Container>
    </Wrapper>
  )
}

export default GalleriesPage
